import React from 'react'
import SurveyperiodComp from '../../Components/SurveyPeriod/SurveyPeriodComp'


function SurveyPeriod() {
    return <>
       <SurveyperiodComp />
    </>
}

export default SurveyPeriod